import { styled } from "styled-components";

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  border: 1px solid #ccc;
`;

export const StyledTh = styled.th`
  background-color: #f2f2f2;
  padding: 10px;
  border: 1px solid #ccc;
`;

export const StyledTd = styled.td`
  padding: 10px;
  border: 1px solid #ccc;
  text-align: left;
  max-width: 100px;
  vertical-align: top;
  ${props => props.right && `text-align: right`}
`;

export const TableContainer = styled.div`
  padding: 20px;
  width: 97%;
  display: flex;
  flex-direction: column;
`;

export const StyledTr = styled.tr`
  &:hover {
    cursor: pointer;
    background-color: rgb(0 0 0 / 9%);
  }
`;

export const TruncatedSpan = styled.span`
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
`

export const ListInsideTable = styled.ol`
  text-align: left;
`